var _class;
import { Children, cloneElement, Component } from 'react';
import './index.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react';

// converter p/ funcional
let PopoverWrapper = observer(_class = class PopoverWrapper extends Component {
  render() {
    const className = classNames('popover-wrapper', this.props.className);
    const {
      children,
      popoverElement
    } = this.props;
    const childrenWithProps = Children.map(children, child => cloneElement(child, {
      popoverElement
    }));
    return <div className={className}>{childrenWithProps}</div>;
  }
}) || _class;
PopoverWrapper.propTypes = {};
PopoverWrapper.defaultProps = {};
PopoverWrapper.displayName = 'PopoverWrapper';
export default PopoverWrapper;